var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.698,
    height: 83.698,
    viewBox: "0 0 83.698 83.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bce0fd;}.b{fill:#013272;}.c{fill:#013b88;}.d{fill:#00429a;}.e{fill:#f6d2bf;}.f{fill:#0075eb;}.g{fill:#f0c3ab;}.h{fill:#1a8cff;}.i{fill:#f7ded0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.553 19.742)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,41.849A41.849,41.849,0,1,0,41.849,0,41.854,41.854,0,0,0,0,41.849Z",
    transform: "translate(-19.553 -19.742)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.224 -2.733)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M63.066,260.879c6.714.376,17.178,1.605,21.091,10.066,1.278,2.759,3.372,10.8,2.875,19.711s0,25.266,0,25.266-11.788-2.275-12.483-1.856c-2.7,1.63-2.725,5.337-13.056,5.337l-6.167-43.169",
    transform: "translate(-41.035 -260.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M105.578,260.673c2.859,0,8.179,2.185,8.179,2.185a52.954,52.954,0,0,1,3.488,6.508,22.334,22.334,0,0,1,1.544,5.476c-8-1.349-11.283,4.621-19.378,1.248l6.167,43.169a40.449,40.449,0,0,1-20.462-5.441,2.3,2.3,0,0,1-1.125-1.964C83.88,290.349,81.174,260.673,105.578,260.673Z",
    transform: "translate(-79.367 -260.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M161,315.821c-.1-18.479-2.091-42.973,12.83-49.506.26,1.352.732,5.126-.493,7.575-3.084,6.167-6.167,6.167-9.251,10.792-3.084,16.959,5.892,34.959,8.873,37.41h0a38.787,38.787,0,0,1-10.833-4.307A2.3,2.3,0,0,1,161,315.821Z",
    transform: "translate(-156.378 -264.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M61.023,419.672l13.758-5.732a3.083,3.083,0,0,0,1.9-2.846v-3.726H92.1v3.726a3.083,3.083,0,0,0,1.9,2.846h0c.217.091-2.456.607-1.6,1.016,3.316,1.592-1.11.831-1.11,2.463L88.052,421c0,1.448-6.113,2.4-7.56,2.4L60.8,430.571a2.621,2.621,0,0,1-2.621-2.621v-4.009A4.626,4.626,0,0,1,61.023,419.672Z",
    transform: "translate(-58.176 -363.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M60.732,435.717l13.3-5.543L84.1,434.517l10.062-4.343h0l13.739,6.184-1.543,8.684a20.236,20.236,0,0,1-6.6,5.152,37.87,37.87,0,0,1-14.891,3.156,52.413,52.413,0,0,1-5.514,0,42.737,42.737,0,0,1-10.621-2.432,52.391,52.391,0,0,1-10.848-5.744v-5.189A4.625,4.625,0,0,1,60.732,435.717Z",
    transform: "translate(-57.885 -379.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M94.691,407.367h15.418v3.726a3.083,3.083,0,0,0,1.9,2.846l-.78.74C94.784,418.872,94.691,407.367,94.691,407.367Z",
    transform: "translate(-76.189 -363.813)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 47.794)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M189.535,459.6v-4.009a4.615,4.615,0,0,1,1.306-3.208l6.209,4.9a4.625,4.625,0,0,1,1.736,3.612v5.068s-2.172-1.059-4.485-2.271-4.766-2.8-4.766-2.8Z",
    transform: "translate(-189.535 -443.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M198.785,457.58v-2.887c0-.881-.479-1.165-1.3-1.774l-6.218,2.995a3.1,3.1,0,0,0-1.736,2.6l-.619,8.523a55.053,55.053,0,0,0,5.879-3.359,34.747,34.747,0,0,1,3.99-2.437Z",
    transform: "translate(-147.535 -444.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M128.63,455.671c.728.043,1.675-1.125,1.675-1.125V444.78h-3.084v9.592S127.9,455.628,128.63,455.671Z",
    transform: "translate(-102.552 -437.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M91.981,428.511l8.824-6.618a1.233,1.233,0,0,1,1.766.3l.457,1.889s-.1.1-1.059,1.322c-.107.13-1.165,1.385-1.165,1.385L98.863,429,95.7,431.46Z",
    transform: "translate(-65.77 -421.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M144.749,428.511l-8.825-6.618a1.233,1.233,0,0,0-1.766.3l-1.744,2.615,5.41,7.574a1.234,1.234,0,0,0,1.774.246Z",
    transform: "translate(-118.538 -421.647)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M89.108,307.407c7.709,7.708,22.838,1.542,22.838,13.876l-.957,9.086a6.167,6.167,0,0,1-3.147,4.833l-8.779,4.877a4.625,4.625,0,0,1-4.492,0L85.793,335.2a6.167,6.167,0,0,1-3.147-4.833l-1.105-10.79a17.02,17.02,0,0,1-.069-2.308C82.048,313.345,87.566,310.491,89.108,307.407Z",
    transform: "translate(-70.606 -293.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M105.125,321.283l-.957,9.086a6.167,6.167,0,0,1-3.147,4.833l-8.779,4.877a4.605,4.605,0,0,1-3.139.469h0s4.426-1.341,7.06-8.472c.807-2.184,1.927-13.747.964-15.16-1.9-2.793-12.527-3.084-15.666-8.266q.232-.289.429-.578c.01-.016.023-.031.034-.047a5.941,5.941,0,0,0,.363-.617C90,315.116,105.125,308.949,105.125,321.283Z",
    transform: "translate(-63.785 -293.531)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.639df8138f193148a3674d4908fd3296.svg";
export { ForwardRef as ReactComponent };